export const initializeKakao = (apiKey) => {
    Kakao.init(apiKey);
    Kakao.isInitialized();
  };